import type { StylesConfig } from 'react-select';

type Option = { value: any; label: string };

export const selectBaseStyles: StylesConfig<Option, false> = {
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
  control: (base, state) => ({
    ...base,
    border: '1px solid lightgray',
    borderRadius: '6px',
    boxShadow: 'none',
    '&:hover': { border: '1px solid lightgray' },
    ...(state.isFocused
      ? {
        borderColor: 'var(--c-primary)',
        boxShadow: '0 0 0 1px var(--c-primary)',
      }
      : {}),
  }),
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isSelected ? 'var(--c-primary)' : undefined,
    color: state.isSelected ? 'white' : 'black',
    '&:hover': {
      backgroundColor: state.isSelected ? 'var(--c-primary)' : '#e0ecfc',
    },
  }),
};

export const selectRightInGroupStyles: StylesConfig<Option, false> = {
  ...selectBaseStyles,
  control: (base, state) => ({
    ...selectBaseStyles.control!(base, state),
    borderRadius: '0px 6px 6px 0px',
    width: '100%',
    minHeight: base.minHeight,
  }),
};
